import { jsxs as o, jsx as e } from "react/jsx-runtime";
import m from "react";
import { match as a } from "ts-pattern";
import { DiscountChip as n } from "../DiscountChip/DiscountChip.js";
const s = (r, i) => a(r).with({
  type: "waitlist"
}, t => t.waitlistLabel).with({
  type: "price"
}, t => t.formattedAmount).with({
  type: "discounted"
}, t => /* @__PURE__ */o(m.Fragment, {
  children: [/* @__PURE__ */e(n, {
    lineThrough: !0,
    background: i,
    children: t.formattedOriginalAmount
  }), " ", t.formattedAmount]
})).exhaustive();
export { s as formatPrice };